import { render, staticRenderFns } from "./DeleteReportModal.vue?vue&type=template&id=01d347e6&scoped=true&"
import script from "./DeleteReportModal.vue?vue&type=script&lang=js&"
export * from "./DeleteReportModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteReportModal.vue?vue&type=style&index=0&id=01d347e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d347e6",
  null
  
)

export default component.exports